// import { useState } from 'react'
import RootLayout from './layouts/RootLayout.jsx'
import SignInPage, { action as SignInAction } from './pages/SignInPage.jsx'
import SignUpPage, { action as SignUpAction } from './pages/SignUpPage.jsx'
import { action as SignOutAction } from './pages/SignOutPage.jsx'
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { getAuthToken, checkNotSignedIn, checkSignedIn, checkAdmin } from './utils/auth.js';

import AccountUnlock, { unlockAccount } from './pages/AccountUnlockPage.jsx';
import AccountConfirm, { confirmAccount } from './pages/AccountConfirmPage.jsx';
import AccountPasswordRequestRecovery, {action as RequestPasswordRecoveryAction} from './pages/AccountPasswordRequestRecoveryPage.jsx';
import AccountPasswordRecover, {action as RecoverPasswordAction} from './pages/AccountPasswordRecoverPage.jsx';
import NewGroupPage, {action as CreateGroupAction, loader as LoadRelationsForGroups } from './pages/NewGroupPage.jsx';
import HomePage, {loader as loadGroupsAndMatches} from './pages/HomePage.jsx';
import GroupAcceptInvitation, { groupAcceptInvitation } from './pages/GroupAcceptInvitation.jsx';
import GroupManagementPage, { loader as groupManagementLoader } from './pages/GroupManagementPage.jsx';

import AdminLayout from './layouts/AdminLayout.jsx'

import TeamListPage from './pages/admin/TeamListPage.jsx'
import TeamShowPage, { loader as loadTeam } from './pages/admin/TeamShowPage.jsx'
import TeamNewPage, { action as CreateTeamAction, loader as loadTeamRelations } from './pages/admin/TeamNewPage.jsx'
import TeamEditPage, { action as EditTeamAction, loader as loadTeamForEditing } from './pages/admin/TeamEditPage.jsx'

import TournamentListPage from './pages/admin/TournamentListPage.jsx'
import TournamentShowPage, { loader as loadTournament } from './pages/admin/TournamentShowPage.jsx'
import TournamentNewPage, { action as CreateTournamentAction } from './pages/admin/TournamentNewPage.jsx'
import TournamentEditPage, { action as EditTournamentAction, loader as loadTournamentForEditing } from './pages/admin/TournamentEditPage.jsx'

import MatchListPage from './pages/admin/MatchListPage.jsx'
import MatchShowPage, { loader as loadMatch } from './pages/admin/MatchShowPage.jsx'
import MatchNewPage, { action as CreateMatchAction, loader as loadMatchRelations} from './pages/admin/MatchNewPage.jsx'
import MatchEditPage, { action as EditMatchAction, loader as loadMatchForEditing } from './pages/admin/MatchEditPage.jsx'

import PlatformPolicyListPage from './pages/admin/PlatformPolicyListPage.jsx'
import PlatformPolicyShowPage, { loader as loadPlatformPolicy } from './pages/admin/PlatformPolicyShowPage.jsx'
import PlatformPolicyNewPage, { action as CreatePlatformPolicyAction, loader as loadPlatformPolicyRelations} from './pages/admin/PlatformPolicyNewPage.jsx'
import PlatformPolicyEditPage, { action as EditPlatformPolicyAction, loader as loadPlatformPolicyForEditing } from './pages/admin/PlatformPolicyEditPage.jsx'

import ImageListPage from './pages/admin/ImageListPage.jsx'
import ImageShowPage, { loader as loadImage } from './pages/admin/ImageShowPage.jsx'
import ImageNewPage from './pages/admin/ImageNewPage.jsx'

import UserUpdatePage, { action as UpdateUserAction, loader as LoadCurrentUser } from './pages/UserUpdatePage.jsx'
import AccountUpdatePasswordPage, { action as AccountUpdatePasswordAction } from './pages/AccountUpdatePasswordPage.jsx';
import GdprDeleteUserPage from './pages/GdprDeleteUserPage.jsx'
import UserOtherPage from './pages/UserOtherPage.jsx'
import ErrorPage from './pages/ErrorPage.jsx'

const router = createBrowserRouter([
  {
    path: '/',
    id: 'root',
    loader: getAuthToken,
    element: <RootLayout/>,
    errorElement: <ErrorPage/>,
    children: [
      {
        index: true,
        id: 'home-page',
        element: <HomePage/>,
        loader: loadGroupsAndMatches
      },
      {
        path: 'sign_in',
        id: 'sign-in',
        element: <SignInPage/>,
        action: SignInAction,
        loader: checkNotSignedIn,
      },
      {
        path: 'sign_up',
        id: 'sign-up',
        element: <SignUpPage/>,
        action: SignUpAction,
        loader: checkNotSignedIn,
      },
      {
        path: 'sign_out',
        id: 'sign-out',
        action: SignOutAction,
        loader: checkSignedIn,
      },
      {
        path: 'user',
        id: 'user',
        loader: checkSignedIn,
        children: [
          {
            path: 'update',
            id: 'user-update',
            element: <UserUpdatePage/>,
            action: UpdateUserAction,
            loader: LoadCurrentUser,
          },
          {
            path: 'update_password',
            id: 'update-password',
            element: <AccountUpdatePasswordPage/>,
            action: AccountUpdatePasswordAction
          },
          {
            path: 'gdpr/delete',
            id: 'user-gdpr-delete',
            element: <GdprDeleteUserPage/>,
          },
          {
            path: 'other',
            id: 'user-other',
            element: <UserOtherPage/>,
          }
        ]
      },
      {
        path: 'groups',
        id: 'groups',
        loader: checkSignedIn,
        children: [
          {
            path: 'new',
            id: 'group-new',
            element: <NewGroupPage/>,
            action: CreateGroupAction,
            loader: LoadRelationsForGroups,
          },
          {
            path: ':groupID/accept_invitation',
            id: 'group-accept-invitation',
            element: <GroupAcceptInvitation/>,
            loader: groupAcceptInvitation,
          },
          {
            path: ':groupID/manage',
            id: 'group-manage',
            element: <GroupManagementPage/>,
            loader: groupManagementLoader,
          }
        ]
      },
      {
        path: 'accounts',
        id: 'accounts',
        children: [
          {
            path: 'unlock',
            id: 'unlock',
            element: <AccountUnlock/>,
            loader: unlockAccount,
          },
          {
            path: 'confirm',
            id: 'confirm',
            element: <AccountConfirm/>,
            loader: confirmAccount,
          },
          {
            path: 'password',
            id: 'password',
            children: [
              {
                path: 'request_recovery',
                id: 'request_recovery',
                element: <AccountPasswordRequestRecovery/>,
                action: RequestPasswordRecoveryAction
              },
              {
                path: 'recovery',
                id: 'recovery',
                element: <AccountPasswordRecover/>,
                action: RecoverPasswordAction,
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/cocofantoelefanto',
    id: 'cocofantoelefanto',
    element: <AdminLayout/>,
    loader: checkAdmin,
    children: [
      {
        path: 'teams',
        id: 'admin-teams',
        element: <TeamListPage/>
      },
      {
        path: 'teams/:id',
        id: 'admin-team',
        element: <TeamShowPage/>,
        loader: loadTeam
      },
      {
        path: 'teams/new',
        id: 'admin-team-new',
        element: <TeamNewPage/>,
        action: CreateTeamAction,
        loader: loadTeamRelations
      },
      {
        path: 'teams/:id/edit',
        id: 'admin-team-edit',
        element: <TeamEditPage/>,
        action: EditTeamAction,
        loader: loadTeamForEditing
      },
      {
        path: 'tournaments',
        id: 'admin-tournaments',
        element: <TournamentListPage/>
      },
      {
        path: 'tournaments/:id',
        id: 'admin-tournament',
        element: <TournamentShowPage/>,
        loader: loadTournament
      },
      {
        path: 'tournaments/new',
        id: 'admin-tournament-new',
        element: <TournamentNewPage/>,
        action: CreateTournamentAction
      },
      {
        path: 'tournaments/:id/edit',
        id: 'admin-tournament-edit',
        element: <TournamentEditPage/>,
        action: EditTournamentAction,
        loader: loadTournamentForEditing
      },
      {
        path: 'tournaments/:tournamentId/matches',
        id: 'admin-matches',
        element: <MatchListPage/>,
      },
      {
        path: 'tournaments/:tournamentId/matches/:id',
        id: 'admin-match',
        element: <MatchShowPage/>,
        loader: loadMatch
      },
      {
        path: 'tournaments/:tournamentId/matches/new',
        id: 'admin-match-new',
        element: <MatchNewPage/>,
        action: CreateMatchAction,
        loader: loadMatchRelations
      },
      {
        path: 'tournaments/:tournamentId/matches/:id/edit',
        id: 'admin-match-edit',
        element: <MatchEditPage/>,
        action: EditMatchAction,
        loader: loadMatchForEditing
      },
      {
        path: 'tournaments/:tournamentId/platform-policies',
        id: 'admin-platform-policies',
        element: <PlatformPolicyListPage/>,
      },
      {
        path: 'tournaments/:tournamentId/platform-policies/:id',
        id: 'admin-platform-policy',
        element: <PlatformPolicyShowPage/>,
        loader: loadPlatformPolicy
      },
      {
        path: 'tournaments/:tournamentId/platform-policies/new',
        id: 'admin-platform-policy-new',
        element: <PlatformPolicyNewPage/>,
        action: CreatePlatformPolicyAction,
        loader: loadPlatformPolicyRelations
      },
      {
        path: 'tournaments/:tournamentId/platform-policies/:id/edit',
        id: 'admin-platform-policy-edit',
        element: <PlatformPolicyEditPage/>,
        action: EditPlatformPolicyAction,
        loader: loadPlatformPolicyForEditing
      },
      {
        path: 'images',
        id: 'admin-images',
        element: <ImageListPage/>
      },
      {
        path: 'images/:id',
        id: 'admin-image',
        element: <ImageShowPage/>,
        loader: loadImage
      },
      {
        path: 'images/new',
        id: 'admin-image-new',
        element: <ImageNewPage/>
      }
    ]
  }
])


function App() {
  return <RouterProvider router={router} />
}

export default App;
